import { useQuery } from "react-query";
import { api } from "utils/api";
import type { OpenCallSubmission } from "../types";
import { submissionKeys } from "./queryKeys";

type OpenCallUserSubmissionsResponse = {
  data: OpenCallSubmission[];
  canPurchaseSubmissions: boolean;
  isEligible: boolean;
  userSubmissionAllowance: number;
};

const getOpenCallUserSubmissions = (openCallId?: string, userId?: string) =>
  openCallId && userId
    ? api.post<OpenCallUserSubmissionsResponse>(`/open-call/user/submissions`, {
        body: JSON.stringify({ openCallId, userId }),
      })
    : Promise.reject(new Error("Invalid open call id or user id"));

const useOpenCallUserSubmissions = (openCallId?: string, userId?: string) =>
  useQuery(
    submissionKeys.user(openCallId, userId),
    () => getOpenCallUserSubmissions(openCallId, userId),
    { enabled: !!userId && !!openCallId }
  );

export { useOpenCallUserSubmissions };
